import { Component, OnInit, HostListener, ElementRef, Directive, Input, AfterViewInit, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DataTransferService } from '../../services/DataTransferService';
import { LocationService } from '../../services/location.service';
import { ReceiptService } from '../../services/receipt.service';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss']
})


export class SidemenuComponent implements OnInit, AfterViewInit {
  ngAfterViewInit(): void {
    this.getUserRoles();
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.dataTransfer.currentUser.subscribe((x) => {
      if (x != null && x != undefined) {
        this.currentUser = x;
        this.hasCashierRole = this.currentUser["Roles"].filter(x => x.Type == 1).length > 0;
        this.hasOutletManagerRole = this.currentUser["Roles"].filter(x => x.Type == 2).length > 0;
        this.hasOperationsRole = this.currentUser["Roles"].filter(x => x.Type == 3).length > 0;
      }
    })
    this.cdRef.detectChanges()
  }
  Activated: boolean = true;
  toggledSideMenu: boolean;
  navStart: Observable<NavigationStart>;
  currentBranch: any;
  hasCashierRole: boolean = true;
  hasOutletManagerRole: boolean = true;
  hasOperationsRole: boolean = true;
  currentUser: any;
  isDisabledOutbound: boolean = false;
  @Input() disableSideMenu;
  constructor(private router: Router,
    private el: ElementRef,
    private locationService: LocationService,
    private receipt: ReceiptService,
    private dataTransfer: DataTransferService,
    private cdRef: ChangeDetectorRef,
  private http: HttpClient) {

    this.toggledSideMenu = true;
    this.Activated = this.router.url != '/dashboard/outlet-selection';
    this.navStart = router.events.pipe(
      filter(evt => evt instanceof NavigationStart)
    ) as Observable<NavigationStart>;

    this.dataTransfer.currentBranch.subscribe((x) => {
      this.currentBranch = x;
      sessionStorage.setItem("branch", JSON.stringify(this.currentBranch));
      var exsistBranch = JSON.parse(sessionStorage.getItem('branch')) as any;
      if (exsistBranch != undefined) {
        this.currentBranch = exsistBranch;
        this.currentBranch = JSON.parse(sessionStorage.getItem('branch'));
      }
    });
    this.currentBranch = JSON.parse(sessionStorage.getItem("branch"));
    this.navStart.subscribe(evt => {
      this.Activated = evt.url != '/dashboard/outlet-selection';
    })
  }
  toggleSideMenu() {
    this.toggledSideMenu = this.toggledSideMenu ? false : true;
  }

  getBranchRolesIcon(roleId) {
    var icon = ''
    switch (roleId) {
      case 1:
        icon += '<span class="armx-icon armx-cashier"></span>';
        break;
      case 3:
        icon += '<span class="armx-icon armx-operations"></span>';
        break;
      case 2:
        icon += '<span class="armx-icon armx-out-mgr"></span>';
        break;
    }
    return icon
  }
  newReceipt() {
    if (this.router.url != '/dashboard/cashier/receipts/create') {
      this.dataTransfer.changeMode('default message');
      this.dataTransfer.changeCountry('default message');
      this.dataTransfer.changeProductGroup('default message');
      this.dataTransfer.changeProductType('default message');
      this.router.navigate(['/dashboard/cashier/receipts/create']);
    }
  }
  ngOnInit() {
    this.receipt.getReceiptTypes((res) => {
      this.isDisabledOutbound = res.filter(x => x.ReceiptTypeId == 2).length > 0;
    }, (err) => {
      });
  }

  @HostListener('document:click', ['$event'])
  handleClick(event: Event) {
    var ev = (event.target as Element).className.trim();
   // event.srcElement.className.trim();
    if (this.el.nativeElement.contains(event.target)) {
      if (ev == 'menu-item' || ev == 'toggle-btn hidden-m-btn')
        this.toggledSideMenu = true;
      else
        this.toggledSideMenu = false;
    }
    else {
      this.toggledSideMenu = true;
    }
  }
  signOut() {

    const token = sessionStorage.getItem('username');
   //console.log("token is", token);
    const finishSignOut = () =>{
      localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
    };

    if(token && environment.identityLogOut){
      const body = new HttpParams().set('token',token);
      const headers =  new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
    this.http.post(environment.identityLogOut, body, {headers})
    .subscribe(
      (res) => finishSignOut(),
      (err) => finishSignOut()
     );
    }
    else{
      finishSignOut();
    
    }
  }
    
  getUserRoles() {
    try {
      var userRoles = JSON.parse(sessionStorage.getItem("branch")).branch.Roles;
      this.hasCashierRole = userRoles.filter(x => x.Role.Type == 1).length > 0;
      this.hasOutletManagerRole = userRoles.filter(x => x.Role.Type == 2).length > 0;
      this.hasOperationsRole = userRoles.filter(x => x.Role.Type == 3).length > 0;
      this.locationService.getLocationSettings();
    }
    catch (ex) {

    }
  }

}
